window.gs = window.gs || {};
(function ($, overlay, gs) {   
	
    "use strict";
    var securityCodeLayer;
	var canCaptchaPlay = true;
    
    gs.captchaShow = function (){
    	securityCodeLayer = new GsBase.modal('#modal-capcha');
    	securityCodeLayer.show($('#modal-capcha'),captchaCallBack);
    	$("#confirmNum").val("");
    	gs.captchaRefresh();
    	//securityCodeLayer.ajax('/cust/login/simpleCaptcha.gs');
    };
    var captchaCallBack = function(){
    	$("#confirmNum").focus();
    }
	gs.captchaClose = function () {
		securityCodeLayer.close($('#modal-capcha'));
		if(window.GsBase && GsBase.noMemord && GsBase.noMemord.captchaFlg ){
			GsBase.noMemord.captchaFlg = false;
		}
	};
	
	gs.captchaSoundPlay = function (){
		var agent=window.navigator.userAgent;
		var ie = agent.indexOf("MSIE");
		var ie8 = agent.indexOf("IE8");

        var trident = agent.indexOf("Trident");
        
        var audioUrl ="/cust/login/audioCaptcha.wav?id=" + Math.random();
        
        var Dns;
        var mcUrl;
        Dns=location.href;
        Dns=Dns.split("//");
        Dns=Dns[1].substr(0,Dns[1].indexOf("/"));

        if(Dns == "www.gsshop.com"){
        	mcUrl = "http://m.gsshop.com";
        	
        }else if(Dns == "awww.gsshop.com"){
           	mcUrl = "http://am.gsshop.com";
        }else{
        	mcUrl = "http://sm21.gsshop.com";
        }
        
        var MaudioUrl =mcUrl+"/audioCaptcha.wav?id=" + Math.random();
        if(ie > 0){
			if (ie8>0)
			{ 
				var ifmAudioElement = document.createElement("iframe");
				ifmAudioElement.id = "ifmAudioCaptcha";
				$('#ifmAudioCaptcha').src = MaudioUrl;
			}else{
				$('#audioCaptcha').html("음성 <BGSOUND  src='" + MaudioUrl + "'  loop='1' />");
			}
		}else{
            if(trident > 0) {
            	$('#audioCaptcha').html("음성 <BGSOUND  src='" + MaudioUrl + "'  loop='1' />");
            } else {
            	$('#audioCaptcha').html("<audio controls autoplay><source src='" + audioUrl + "' type='audio/wav'></audio>");
            }
		}
		
	};
	
	gs.captchaRefresh = function (){
		$("#capchaimg").attr("src","/cust/login/simpleCaptcha.png?id=" + Math.random()+"&set=" + $("#id").val());
	};
    
})(jQuery, gs.overlay, window.gs);